import React, { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MyContext = createContext('');

const MyContextProvider = ({ children }) => {
  const Navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('Token');
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
      Navigate('/login');
    }
  }, [Navigate]);

  const login = (token) => {
    localStorage.setItem('Token', token); // Fixed: use 'Token' to match Login.js
    setIsLoggedIn(true);
    Navigate('/home');
  };

  const logout = () => {
    localStorage.removeItem('Token'); // Fixed: use 'Token' to match Login.js
    setIsLoggedIn(false);
    Navigate('/login');
  };

  return (
    <MyContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyContextProvider };
